<main>
  <div class="content">
    <h3>Scanned Barcodes:</h3>
    <ul>
      <li *ngFor="let barcode of scannedBarcodes">{{ barcode }}</li>
    </ul>

    <h3>Scanned barcodes with existing lots</h3>
    <table>
      <thead>
        <tr>
          <th>Lot Id</th>
          <th>Item Code</th>
          <th>Original Quantity</th>
          <th>Current Quantity</th>
          <th>Warehouse Reference</th>
          <th>Location Reference</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let lot of lots">
          <!-- <td>{{ lot.lotId }}</td>
          <td>{{ lot.itemCode }}</td>
          <td>{{ lot.originalQuantity }}</td>
          <td>{{ lot.currentQuantity }}</td> -->
          <!-- <td>{{ lot.warehouseReference }}</td>
          <td>{{ lot.locationReference }}</td> -->
        </tr>
      </tbody>
    </table>
  </div>
</main>
